import React from 'react'
import { Tile } from 'app/ecommerce/common/components'
import { catalogType } from 'shared/utils'
import type { IntlShape } from 'react-intl'
import { injectIntl } from 'react-intl'
import type { ItemInfos } from 'shared/store/ecommerce/order'
import type { ClickAndCollectPromotion, Coupon } from 'shared/types'

type Props = {
    id: string,
    name?: string,
    price?: number,
    imageUrl?: string,
    routeId?: string,
    IconTopRight?: any,
    type?: string,
    hasAllergens?: boolean,
    categoryId?: string,
    currentSelectedOnStore?: (currentItemInfos: ItemInfos) => void,
    promotion?: ClickAndCollectPromotion,
    onClick?: () => void,
    catalogRoute?: string,
    isKingdomPoints?: boolean,
    intl: IntlShape,
    promotionToApply?: ClickAndCollectPromotion,
    coupon: Coupon
}

const DisplayableProductTile = injectIntl((props: Props) => {
    const {
        name,
        id,
        price,
        imageUrl,
        routeId,
        type,
        hasAllergens,
        IconTopRight,
        categoryId,
        currentSelectedOnStore,
        onClick,
        catalogRoute,
        isKingdomPoints,
        intl,
        coupon,
        promotionToApply,
        ...rest
    } = props

    const getCatalogRoute = (type?: string, isKingdomPoints?: boolean) => {
        let route
        switch (type) {
            case catalogType.MENU:
                route = 'routes.clickandcollect.menu'
                break
            case catalogType.PRODUCT:
                route = isKingdomPoints
                    ? 'routes.clickandcollect.catalog'
                    : 'routes.clickandcollect.product'
                break
            case catalogType.PRODUCT_GROUP:
                route = 'routes.clickandcollect.product.group'
                break
            case catalogType.GAME:
                route = 'routes.clickandcollect.game'
                break
            default:
                route = undefined
        }
        return intl.formatMessage({ id: route })
    }

    return (
        <Tile
            id={id}
            name={name}
            price={price}
            imageUrl={imageUrl}
            routeId={routeId}
            hasAllergens={hasAllergens}
            IconTopRight={IconTopRight || null}
            displayableProduct={true}
            catalogRoute={
                catalogRoute || getCatalogRoute(type, isKingdomPoints)
            }
            promotionToApply={promotionToApply}
            coupon={coupon}
            currentSelectedOnStore={currentSelectedOnStore}
            categoryId={categoryId}
            onClick={onClick}
            type={type}
            {...rest}
        />
    )
})

export { DisplayableProductTile }
